import React, { Component } from "react";
import { Outlet } from "react-router-dom";
class HomeLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <Outlet props={this.props} />
      </>
    );
  }
}
export default HomeLayout;
